import React, { useEffect, useState } from "react";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Icon from "@mui/material/Icon";
import { CardActionArea } from "@mui/material";

import Header from "./components/Header";
import Banner from "./components/Banner";
import Footer from "./components/Footer";
import { database_id } from "./const";
import { fetchData } from "./js/main";
import { useNavigate } from "react-router-dom";

export default function Home(props) {
  const [database, setDatabase] = useState();
  useEffect(() => {
    (async () => {
      let database = await fetchData("get", "/database/" + database_id);
      setDatabase(database);
    })();
  }, []);

  return (
    <div>
      {database && (
        <>
          <Header profile={props.profile} />
          <Banner database={database} />
          <div style={{ textAlign: "center" }}>
            <h1 className="bold" style={{ padding: "20px 0px" }}>
              Collections
            </h1>
            <Container>
              <Grid container spacing={3}>
                {database.collections.map((collection, key) => (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    lg={4}
                    xl={3}
                    key={key}
                    align="center"
                  >
                    <CollectionCard collection={collection} />
                  </Grid>
                ))}
              </Grid>
            </Container>
            <br />
            <br />
            <br />
            <Footer />
          </div>
        </>
      )}
    </div>
  );
}

function CollectionCard({ collection }) {
  const navigate = useNavigate();
  return (
    <Card
      onClick={() =>
        navigate(process.env.PUBLIC_URL + "/collection/" + collection.code)
      }
    >
      <CardActionArea>
        <CardMedia style={{ paddingTop: "10px" }}>
          <Icon style={{ fontSize: "6rem", color: "#684391" }}>storage</Icon>
        </CardMedia>
        <CardContent>
          <Typography
            gutterBottom
            component="div"
            style={{ height: "40px", fontSize: "1rem", color: "#444" }}
          >
            {collection.name}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
